/**
 * 검색 폼 텍스트 입력 앞뒤 공백 제거 (2026-10-12).
 *
 * 목록 검색 폼은 전부 `<form method="get">` + `<input type="text" name="keyword">` 구조라
 * 템플릿을 개별 수정하지 않고 document 위임 리스너 2개로 일괄 처리한다.
 *  - submit(capture): Enter·[검색] 버튼 제출 직전 그 폼의 텍스트 입력을 trim.
 *  - focusout      : 입력창을 떠날 때 trim — `<select onchange="form.submit()">` 즉시검색은
 *                    프로그램 submit() 이라 submit 이벤트를 안 거치지만, 드롭다운 클릭 시
 *                    입력창이 먼저 blur 되므로 이 경로로 trim 된 값이 전송된다.
 * GET 폼만 대상이라 등록/수정 폼(POST·fetch JSON)의 본문·메모 입력에는 영향이 없다.
 * 서버 쪽도 각 *SearchRequest 의 setKeyword 가 trim 하므로(주소창 직접 입력 경로) 이중 안전.
 */

function isGetForm(form) {
    return form instanceof HTMLFormElement && form.method === 'get';
}

function isTextInput(el) {
    if (!(el instanceof HTMLInputElement)) return false;
    const type = (el.getAttribute('type') || 'text').toLowerCase();
    return type === 'text' || type === 'search';
}

function trimInput(el) {
    const v = el.value;
    if (typeof v !== 'string') return;
    const t = v.trim();
    if (t !== v) el.value = t;
}

export default function installSearchTrim(doc = document) {
    // 제출 직전 — capture 로 걸어 폼 자체의 submit 핸들러보다 먼저 값이 정리되게 한다.
    doc.addEventListener('submit', (e) => {
        const form = e.target;
        if (!isGetForm(form)) return;
        form.querySelectorAll('input').forEach((el) => {
            if (isTextInput(el)) trimInput(el);
        });
    }, true);

    // 입력창 이탈 — onchange 즉시검색(프로그램 submit) 경로 대비
    doc.addEventListener('focusout', (e) => {
        const el = e.target;
        if (!isTextInput(el)) return;
        if (!isGetForm(el.form)) return;
        trimInput(el);
    }, true);
}
